// @flow
import { getCreator, postCreator } from '../../../../http';
import environment from '../../../../environment';

export const endpoints = Object.freeze({
  POST_PROGRESS_COURIER: `${environment.apiUrl}/sale/:orderId/progress/ship`,
  POST_PROGRESS_QEMPO: `${environment.apiUrl}/sale/:orderId/progress/deliver-qempo`,
  GET_COURIERS: `${environment.apiUrl}/meta/couriers/:country`,
});
export const postProgressCourierApi = postCreator(fetch, endpoints.POST_PROGRESS_COURIER);
export const postProgressQempoApi = postCreator(fetch, endpoints.POST_PROGRESS_QEMPO);
export const getCouriersApi = getCreator(fetch, endpoints.GET_COURIERS);



// WEBPACK FOOTER //
// ./src/modules/order/Sale/deliver/api.js